import { COLORS } from 'parameters/index'
import { DomainTheme } from 'components/patterns/themes/context/ThemeProvider'

const StrongMatchOfferTheme: DomainTheme = {
	icon: {
		primaryFill: COLORS.WHITE,
		secondaryFill: COLORS.WHITE
	},
	text: { color: COLORS.WHITE },
	ribbon: {
		background: { type: 'preset', value: 'primaryPurple' },
		border: 'none'
	}
}

const WeakMatchOfferTheme: DomainTheme = {
	icon: {
		primaryFill: COLORS.KSU_PURPLE,
		secondaryFill: COLORS.KSU_PURPLE
	},
	text: { color: COLORS.KSU_PURPLE },
	ribbon: {
		background: { type: 'preset', value: 'lightPurple' },
		border: 'none'
	}
}

const StaticOfferTheme: DomainTheme = {
	icon: {
		primaryFill: COLORS.JET_BLACK,
		secondaryFill: COLORS.LEGAL_GRAY
	},
	text: { color: COLORS.JET_BLACK },
	ribbon: {
		background: { type: 'preset', value: 'grey' },
		border: 'none'
	}
}

export { StaticOfferTheme, StrongMatchOfferTheme, WeakMatchOfferTheme }
